import React from 'react';
import './Spinner.scss';


const Spinner = () => {
  

  return (
    <div className="spinnerContainer">
       <svg className="spinner" width="80" height="80" viewport="0 0 80 80" tabIndex={-1}>
            <circle r="36" cx="40" cy="40" fill="transparent" strokeDasharray="250" strokeDashoffset="0" tabIndex={-1}></circle>
       </svg>
    </div>
    
  );
};

export default Spinner;
